<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Security.User.username')}}:</div>
        <input class="e-input e-input-group" id="userName" name="UserName" maxLength="25" v-model="userName" @blur="setChildProps" @keydown="stopEvent"/>
      </div>
    </div>
     <div v-show="showNe"  class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('DeployManagement.neName')}}:</div>
        <input class="e-input e-input-group" id="neName" name="neName" maxLength="25" v-model="neName" @blur="setChildProps" @keydown="stopEvent"/>
      </div>
    </div>
    <div v-show="showState" class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{dropdownMessage}}:</div>
        <ejs-dropdownlist class="e-input" ref="list" :dataSource='signInDropdownList' :index='0' @select="setChildProps"></ejs-dropdownlist>
      </div>
    </div>
    <div v-show="showModel" class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{dropdownMessage}}:</div>
        <ejs-combobox class="e-input" ref="model" :dataSource='operDropdownList' :fields='fields' @select="setChildProps"></ejs-combobox>
      </div>
    </div>
    <div class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Security.selectDate')}}:</div>
        <ejs-daterangepicker
          class="e-input"
          ref="datePicker"
          :format="dateFormat"
          :separator="separate"
          @change="setChildProps"
          :allowEdit="false"
          :max="endDate"
          v-model="pickerTime"
          @keydown.native="stopEvent"
        ></ejs-daterangepicker>
      </div>
    </div>
    <div v-show="showTypeState" class="row h-row-inputBox">
      <div class="col-sm-12 h-col-inputBox">
        <div class="h-inputLit">{{$t('Security.fileType')}}:</div>
        <ejs-dropdownlist class="e-input" ref="fileTypeSelect" :dataSource='fileType.list' :fields='fileType.listFields' v-model='fileType.checkValue' @blur="setChildProps" @keydown="stopEvent"></ejs-dropdownlist>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvancedSearch",
  props: {
    signInOrOperation: Number,
    queryOrExport: Number
  },
  data() {
    return {
      userName: "",
      neName:"",
      dropdownList:"",
      signInDropdownList: [
        { text: `${this.$t('Common.all')}`, value: '' },
        { text: `${this.$t('Security.success')}`, value: 1 },
        { text: `${this.$t('Security.failure')}`, value: 0 },
        { text: `${this.$t('Security.forbid')}`, value: -1 }
      ],
      operDropdownList: [],
      dateFormat: "yyyy-MM-dd",
      dropdownMessage: `${this.$t('Security.Log.result')}`,
      separate: "~",
      pickerTime: '',
      dataSource: [],
      showState: true,
      showModel: false,
      showTypeState: true,
      showNe: true,
      endDate: new Date(),
      fileType: {
        listFields: { text: 'name', value: 'value' },
        list: [
          { name: 'txt', value: 'txt' },
          { name: 'xlsx', value: 'xlsx' },
          { name: 'csv', value: 'csv' },
        ],
        checkValue: 'txt'
      },
      fields: {
        value: 'id',
        text: 'text',
      //  groupBy: 'groupName'
      }
    };
  },
  methods: {
    setChildProps(args) {
      let props = {userName: this.userName, time: this.pickerTime,fileType:this.fileType.checkValue,neName:this.neName,dropdownList:this.dropdownList};
      if (typeof(args) !=='undefined') {
        if(!!args.itemData){
          if(this.signInOrOperation === 0){
          props.dropdownList = args.itemData.value;
          this.dropdownList = args.itemData.value;
          } else {
           props.dropdownList = args.itemData.value;
           this.dropdownList = args.itemData.value;
          }
        }
      }
      this.$emit("childProps",props);
    },
    setParams() {
      if (this.signInOrOperation === 0) {
        this.showState = true;
        this.showModel = false;
         this.showNe = false;
        this.showTypeState = false;
        this.dropdownMessage = `${this.$t('Security.Log.result')}`;
        this.dateFormat = 'yyyy-MM-dd';
      } else {
        this.dropdownMessage = `${this.$t('Security.Log.module')}`;
        this.findOperName();
        this.showState = false;
        this.showModel = true;
         this.showNe = true;
        this.showTypeState = this.queryOrExport==1?true:false;
        this.dateFormat = "yyyy-MM-dd";
      }
    },
    findOperName() {
      let That = this;
      this.$axios.get('/lte/ems/res/findResourceGroupLev?parentId=0', {} ).then((res) => {
        let result = res.data;
        let list = [];
        if(result!=null) {
          list.push({ id:"", text: `${That.$t('Common.all')}`, value: "", pid: "" });
          result.forEach((rd) => {
            let item = { id: rd.id, text: rd.nameStr, value: rd.resKey, pid: rd.parentId, groupName: rd.groupName };
            list.push(item);
          });
        }
        That.operDropdownList = list;
        That.$refs.model.ej2Instances.index = 0;
      })
    },
    stopEvent(event) {
      if (event.keyCode == 13) {
        event.cancelBubble = true;
        event.returnValue = false;
        return false;
      }
    }
  },
  watch: {
    signInOrOperation() {
      this.setParams();
    },
    queryOrExport() {
      this.setParams();
    }
  },
  mounted() {
    this.setParams();
  }
};
</script>
